import { NavLink, Link } from "react-router-dom";
import {
  Gauge,
  Inbox,
  KanbanSquare,
  ListTodo,
  Calendar,
  Settings,
  ExternalLink,
  Plus,
  ListPlus,
} from "lucide-react";

const NAV = [
  { to: "/admin/journey/dashboard", label: "Dashboard", icon: Gauge },
  { to: "/admin/journey/inbox", label: "Inbox", icon: Inbox },
  { to: "/admin/journey/kanban", label: "Kanban", icon: KanbanSquare },
  { to: "/admin/journey/tasks", label: "Aufgaben", icon: ListTodo },
  { to: "/admin/journey/calendar", label: "Kalender", icon: Calendar },
  { to: "/admin/journey/settings", label: "Einstellungen", icon: Settings },
];

export default function JourneySidebar({ onNavigate }) {
  return (
    <aside
      data-testid="journey-sidebar"
      className="flex h-full w-64 shrink-0 flex-col border-r border-white/5 bg-[#050607]"
    >
      <div className="flex items-center gap-3 border-b border-white/5 px-5 py-5">
        <img
          src="/pine-logo.svg"
          alt=""
          aria-hidden="true"
          className="h-7 w-7 brightness-0 invert opacity-90"
        />
        <div className="leading-tight">
          <div className="text-[11px] font-medium uppercase tracking-[0.18em] text-emerald-400/80">
            PINE
          </div>
          <div className="text-sm font-semibold text-zinc-100">
            Journey Control
          </div>
        </div>
      </div>

      <div className="space-y-2 border-b border-white/5 px-3 py-3">
        <Link
          to="/admin/journey/quick-add"
          onClick={onNavigate}
          data-testid="journey-nav-quick-add"
          className="flex items-center justify-center gap-2 rounded bg-emerald-500 px-3 py-2 text-xs font-semibold text-zinc-950 transition hover:bg-emerald-400"
        >
          <Plus className="h-4 w-4" />
          Lead erfassen
        </Link>
        <Link
          to="/admin/journey/leads/new"
          onClick={onNavigate}
          data-testid="journey-nav-lead-new"
          className="hidden items-center justify-center gap-2 rounded border border-white/10 px-3 py-1.5 text-[11px] text-zinc-400 transition hover:border-white/20 hover:text-zinc-200 lg:flex"
        >
          <ListPlus className="h-3.5 w-3.5" />
          Vollständig erfassen
        </Link>
      </div>

      <nav className="flex-1 space-y-0.5 px-2 py-4">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            onClick={onNavigate}
            data-testid={`journey-nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              [
                "flex items-center gap-3 rounded px-3 py-2 text-sm transition",
                isActive
                  ? "bg-emerald-500/10 text-emerald-300"
                  : "text-zinc-400 hover:bg-white/[0.04] hover:text-zinc-100",
              ].join(" ")
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-white/5 px-3 py-4">
        <Link
          to="/"
          target="_blank"
          rel="noreferrer"
          data-testid="journey-link-public-site"
          className="flex items-center gap-2 rounded px-3 py-2 text-xs text-zinc-500 transition hover:bg-white/[0.04] hover:text-zinc-300"
        >
          <ExternalLink className="h-3.5 w-3.5" />
          Öffentliche Website
        </Link>
      </div>
    </aside>
  );
}
